<app-generic-calendar
  [(value)]="this.field.fieldValue"
  [placeholder]="'---'"
  [yearRange]="'1950:2050'"
  [mask]="'99.99.9999'"
  [dateFormat]="'dd.mm.yy'"
  (onInputChangeValid)="onValueChange($event)"
  (onSelect)="onValueChange($event)"
></app-generic-calendar>
